import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Footer Component
 * Provides the footer section for the scottishpower business application
 * Contains legal links, contact information, and company branding
 */
@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  year: number = new Date().getFullYear();
  /**
   * Constructor for FooterComponent
   * Currently no initialization logic required as the component
   * primarily serves as a static content container
   */
}
